export default "__VITE_ASSET__KYJsujmA__"